import React from 'react';

const IphoneFrame = ({ children }) => {
	return (
		<div className="phone-frame">
			<div className="phone-sides">
				<div className="phone-header">
					<div className="speaker" />
					<div className="camera" />
				</div>
				{children}
			</div>
		</div>
	);
};

export default IphoneFrame;
